import { render, staticRenderFns } from "./DashboardActivityListItem.vue?vue&type=template&id=3a70cfe9"
import script from "./DashboardActivityListItem.vue?vue&type=script&lang=js"
export * from "./DashboardActivityListItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardActivityListItem.vue?vue&type=style&index=0&id=3a70cfe9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports